module.exports = __webpack_public_path__ + "img/chivas-bg-age.ee5915c5.jpg";